import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-instantanswerlearnmore-click';
/**
 * User clicks learn more button in instant answer section
 */
export function trackCxFoundationsInstantanswerlearnmoreClick(retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, brandToken },
    });
}
